"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetBusinessGuideService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const llm_consensus_1 = require("@branch-ts/llm-consensus");
const fsExhibitionMechanism_1 = require("@branch-ts/biome-media-web/src/file/fsExhibitionMechanism");
const cps_consensus_1 = require("@branch-ts/cps-consensus");
const probe_consensus_1 = require("@branch-ts/probe-consensus");
const practice_probe_web_1 = require("@branch-ts/practice-probe-web");
const puri_1 = require("@branch-ts/puri");
const web_consensus_1 = require("@branch-ts/web-consensus");
const with_caution_1 = require("with-caution");
require("./interlock.PaymentRequired");
const service_VersetBilling_1 = require("./service.VersetBilling");
const service_VersetProbe_1 = require("./service.VersetProbe");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
const probeSetupGuide_1 = require("./view/probeSetupGuide");
const probeInstallCommand_1 = require("./probeInstallCommand");
const probeReconnectResolution_1 = require("./probeReconnectResolution");
let VersetBusinessGuideService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetBusinessGuideService = class {
        static { _classThis = this; }
        constructor() {
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetBillingService: service_VersetBilling_1.VersetBillingService,
                VersetProbeService: service_VersetProbe_1.VersetProbeService,
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
            });
            this.missingAccessRequests = new Map();
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetBusinessGuideService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        async initialize() {
            this.probeSetupBinding = practice_probe_web_1.ProbeExplorerMechanism.registerAddProbe(probeSetupGuide_1.showProbeSetupGuide);
            this.registerPaymentRequiredGuide();
            this.registerNoProbeSetupGuide();
            (0, probeReconnectResolution_1.registerProbeReconnectResolution)(this.deps.VersetProbeService.probeSessionManager, option => this.deps.VersetProbeService.requestProbe(option));
        }
        async destroy() {
            this.probeSetupBinding?.cancel();
        }
        handleMissingFileSystem() {
            return this.handleMissingDeviceAccess("file", () => !!fsExhibitionMechanism_1.FSExhibitionRegistryMechanism.default);
        }
        handleMissingTerminal(isReady) {
            return this.handleMissingDeviceAccess("term", isReady);
        }
        handleMissingDeviceAccess(shortcut, isReady) {
            const pending = this.missingAccessRequests.get(shortcut);
            if (pending) {
                return pending;
            }
            const request = this.checkMissingDeviceAccess(shortcut, isReady).finally(() => {
                this.missingAccessRequests.delete(shortcut);
            });
            this.missingAccessRequests.set(shortcut, request);
            return request;
        }
        listDeviceInventory() {
            this.deviceInventoryRequest ??= this.deps.VersetRequireLoginService.server.rpcs.VersetUserProbeService.listMyProbes({ count: 1 }).finally(() => {
                this.deviceInventoryRequest = undefined;
            });
            return this.deviceInventoryRequest;
        }
        async checkMissingDeviceAccess(shortcut, isReady) {
            try {
                // The session manager sees online candidates, not all paired devices.
                // An empty live session is not proof that installation is missing.
                const [devices, reason, ...errors] = await this.listDeviceInventory();
                if (isReady()) {
                    return true;
                }
                if (reason || !devices) {
                    web_consensus_1.CommonUI.error(with_caution_1.CautionUtil.error(reason || "Unknown", ...errors));
                    return true;
                }
                if (devices.items.length === 0) {
                    (0, probeSetupGuide_1.showProbeSetupGuide)();
                    return true;
                }
                const sessions = this.deps.VersetProbeService.probeSessionManager;
                if (sessions.situations.get("initialization") !== "ready") {
                    web_consensus_1.CommonUI.toast(`Device connections are still loading. Try @${shortcut} again shortly.`);
                }
                else if (sessions.hasOnlineProbe) {
                    const access = shortcut === "file" ? "file" : "terminal";
                    const setting = shortcut === "file" ? "filesystem" : "terminal";
                    web_consensus_1.CommonUI.toast(`Your Device is connected, but ${access} access is not ready. Check its ${setting} access and try @${shortcut} again.`);
                }
                else if (shortcut === "term") {
                    // A recorded device may belong to another computer. Keep pairing available here.
                    (0, probeSetupGuide_1.showProbeSetupGuide)();
                }
                else {
                    web_consensus_1.CommonUI.toast(`Your Device is offline. Run ${probeInstallCommand_1.probeNpxCommand} on that computer, keep it running, then try @${shortcut} again.`);
                }
            }
            catch (error) {
                web_consensus_1.CommonUI.error(error);
            }
            return true;
        }
        gateLLMExchange(exchange, option) {
            return {
                complete: async (request) => {
                    const [result, reason, ...errors] = await exchange.complete(request);
                    if (reason === "InsufficientCredit") {
                        return [, "PaymentRequired", ...errors];
                    }
                    if (reason) {
                        return [, reason, ...errors];
                    }
                    return [result];
                },
            };
        }
        registerPaymentRequiredGuide() {
            llm_consensus_1.InterlockRegistryMechanism.registerResolution({
                cause: "PaymentRequired",
                handling: () => this.deps.VersetBillingService.showPaymentRequiredGate(),
                sanityCheck: async () => {
                    const [billing, reason] = await this.deps.VersetRequireLoginService.server.rpcs.VersetUserBillingService.getMyBilling({});
                    if (reason || !billing) {
                        return {
                            pass: false,
                            hint: "We could not confirm your available AI usage yet.",
                        };
                    }
                    const hasSpendableBalance = billing.balances.some((balance) => {
                        return balance.point === billing.pointType && balance.spendable > 0;
                    });
                    return hasSpendableBalance
                        ? { pass: true }
                        : {
                            pass: false,
                            hint: billing.subscription?.state.startsWith("active") && billing.subscription.plan && billing.subscription.plan !== "free"
                                ? "Add one-time AI usage, or wait for your included allowance to refresh before retrying."
                                : "Continue with Standard, or wait for your included allowance to refresh before retrying.",
                        };
                },
            });
        }
        async handleNoProbeSetup() {
            const [inventory, reason, ...errors] = await this.deps.VersetProbeService.refreshRecordedProbeInventory();
            if (reason || !inventory) {
                web_consensus_1.CommonUI.error(with_caution_1.CautionUtil.error(reason || "Unknown", ...errors));
            }
            else if (inventory.probeURIs.length === 0) {
                (0, probeSetupGuide_1.showProbeSetupGuide)();
            }
            else {
                web_consensus_1.CommonUI.toast(`A Device is already recorded. Run ${probeInstallCommand_1.probeNpxCommand} on that computer and keep it running to reconnect.`);
            }
        }
        registerNoProbeSetupGuide() {
            llm_consensus_1.InterlockRegistryMechanism.registerResolution({
                cause: "NoProbeSetup",
                handling: () => this.handleNoProbeSetup(),
                sanityCheck: async ({ interlock }) => {
                    const [inventoryResult, sessionResult] = await Promise.all([
                        this.deps.VersetProbeService.refreshRecordedProbeInventory(),
                        this.deps.VersetProbeService.probeSessionManager.sync(),
                    ]);
                    const [, inventoryReason] = inventoryResult;
                    if (inventoryReason)
                        return { pass: false, hint: "We could not confirm your recorded Devices yet. Try again shortly." };
                    const [, sessionReason] = sessionResult;
                    if (sessionReason)
                        return { pass: false, hint: "We could not refresh Device access yet. Try again shortly." };
                    const detail = interlock.detail;
                    let probeURI = detail && typeof detail === "object" && "probeURI" in detail && typeof detail.probeURI === "string"
                        ? detail.probeURI : undefined;
                    const cwd = detail && typeof detail === "object" && "cwd" in detail && typeof detail.cwd === "string" ? detail.cwd : undefined;
                    if (cwd) {
                        try {
                            const cwdInfo = cps_consensus_1.CPSProtocol.FilePathFamilyURI.parse(cwd);
                            const source = cwdInfo && puri_1.PURI.decomposeVendor(cwdInfo.vendor);
                            if (!source || source.protocol !== "probe" || source.kind !== "probe")
                                return { pass: false };
                            const target = probe_consensus_1.ProbeProtocol.ProbeURI.build({ vendor: source.vendor, probeId: source.id });
                            if (probeURI && probeURI !== target)
                                return { pass: false };
                            probeURI = target;
                        }
                        catch {
                            return { pass: false };
                        }
                    }
                    const probes = this.deps.VersetProbeService;
                    if (probes.hasReadyHostExecution(probeURI, cwd))
                        return { pass: true };
                    const [, reason] = probes.getHostExecFileSystemBindings();
                    return {
                        pass: false,
                        hint: reason === "NoProbeSetup"
                            ? `Install and run a local Probe with: ${probeInstallCommand_1.probeNpxCommand}`
                            : reason === "ProbeNotReady"
                                ? "Device access is still loading. Wait for it to become ready."
                                : "Execution and filesystem access must be ready on the selected Device before retrying.",
                    };
                },
            });
        }
    };
    return VersetBusinessGuideService = _classThis;
})();
exports.VersetBusinessGuideService = VersetBusinessGuideService;
